import {
  isSubTreeKey,
  keyPrefix,
} from '../../client/components/NavigationMenu/utils';
import { buildKey, flattenSubMembers, toFlatObjectMembers } from './utils';

const buildFlatTreeMember = (prefix, key, node) => {
  const nodeKey = `/${keyPrefix(prefix, buildKey(key))}`;
  const subMembers = flattenSubMembers(nodeKey, node);

  const flattendCurrentNode = {
    [nodeKey]: toFlatObjectMembers(nodeKey)(node),
  };
  return {
    ...flattendCurrentNode,
    ...subMembers,
  };
};

const toFlatTree =
  (prefix) =>
  (treeAccumulator, [key, node]) =>
    isSubTreeKey(key) || node.data
      ? {
          ...treeAccumulator,
          ...buildFlatTreeMember(prefix, key, node),
          ...flattenTree(node, keyPrefix(prefix, buildKey(key))),
        }
      : treeAccumulator;

export const flattenTree = (tree, prefix) => {
  return Object.entries(tree).reduce(toFlatTree(prefix), {});
};
